export const getAddOnClickFunc =
  (mappingFieldsArrState, controlButtonStringIdState) => (e) => {
    const [, setMappingFieldsArrStateValue] = mappingFieldsArrState;

    setMappingFieldsArrStateValue((prevValue) => {
      return [
        ...prevValue,
        {
          bitrixField: {
            nameId: null,
          },
          optimaField: {
            nameId: null,
          },
          isNew: true,
        },
      ];
    });

    const [, setControlButtonStringIdStateValue] = controlButtonStringIdState;
    setControlButtonStringIdStateValue("remove");
  };
